import { Field, useField } from "formik";
import { ReactNode } from "react";

interface SelectInputProps {
  name: string;
  label: ReactNode;
  moreinfo?: string;
  prompt?: string;
  options: Array<number | string>;
}

const SelectInput = ({
  name,
  label,
  moreinfo,
  prompt = "",
  options,
}: SelectInputProps) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    helpers.setValue(e.target.value);
  };

  return (
    <div className="input-container">
      <label htmlFor={name} className="required">
        <span>{label}</span>
        {moreinfo && <span className="more-info">{moreinfo}</span>}
        {meta.error && <span className="validation-error">{meta.error}</span>}
      </label>

      <div className={`input-wrapper select-wrapper long ${meta.error ? "has-error" : ""}`}>
        <Field
          as="select"
          id={name}
          name={name}
          value={field.value}
          onChange={handleChange}
          className={`select-input ${meta.error ? "has-error" : ""}`}
        >
          <option value="" disabled hidden>
            {prompt}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </Field>
      </div>
    </div>
  );
};

export default SelectInput;
